export type SelfieValidatingLocationState = {
  sessionId: string
}

export function parseSelfieValidatingLocationState(state: unknown): SelfieValidatingLocationState | null {
  if (typeof state !== 'object' || state === null) {
    return null
  }
  const { sessionId } = state as Record<string, unknown>
  if (typeof sessionId !== 'string' || sessionId === '') {
    return null
  }
  return { sessionId }
}
